import axios from "axios";
import rootAPI from "./switchAPI";

axios.defaults.withCredentials = true;

export const logIn = `${rootAPI}/users/log-in`;